import { AutogenLayoutStopShowasQuickInfo } from "./autogen/AutogenLayoutStopShowasQuickInfo";

export class StopShowasQuickInfo extends AutogenLayoutStopShowasQuickInfo {
}
